/**
 * Connection-lost overlay. Shown when WS isn't open.
 */

export interface ConnectionLostHandle {
  setVisible(v: boolean): void;
  dispose(): void;
}

const ROOT_ID = 'cm-connection-lost';

export function createConnectionLost(stage: HTMLElement): ConnectionLostHandle {
  ensureStyles();
  const root = document.createElement('div');
  root.id = ROOT_ID;
  root.innerHTML = `
    <div class="cm-cl-grid">
      <span class="cm-cl-spinner"></span>
      <p class="cm-cl-text">Reconnecting…</p>
    </div>
  `;
  root.style.display = 'none';
  stage.appendChild(root);

  return {
    setVisible(v: boolean): void {
      root.style.display = v ? '' : 'none';
    },
    dispose() {
      root.remove();
    },
  };
}

function ensureStyles(): void {
  if (document.getElementById('cm-cl-style')) return;
  const s = document.createElement('style');
  s.id = 'cm-cl-style';
  s.textContent = `
    #${ROOT_ID} {
      position: absolute;
      inset: 0;
      background: rgba(10, 14, 39, 0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 5;
    }
    #${ROOT_ID} .cm-cl-grid {
      text-align: center;
      color: rgba(255,255,255,0.9);
    }
    #${ROOT_ID} .cm-cl-spinner {
      display: inline-block;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      border: 4px solid rgba(255,255,255,0.2);
      border-top-color: var(--sg-primary, #A855F7);
      animation: cm-cl-spin 0.8s linear infinite;
    }
    @keyframes cm-cl-spin { to { transform: rotate(360deg); } }
    #${ROOT_ID} .cm-cl-text {
      font-family: 'Inter', sans-serif;
      font-size: 26px;
      margin-top: 24px;
    }
  `;
  document.head.appendChild(s);
}
